
import { Component, ModelSync, Prop, Vue, Watch } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { ControlButtonBar } from "@/oxygen/classes/lib/types";
import { mapOptionToButtonBar } from "@/oxygen/classes/lib/classes";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import UnitDropdown from "@/components/Reusable/CustomInputs/UnitInput/UnitDropdown.vue";

@Component({
  components: { UnitDropdown, Dropdown, Icon }
})
export default class OxygenButtonBarInput extends Vue {
  @Prop()
  control!: ControlButtonBar;

  @ModelSync("value", "input")
  syncedValue?: unknown;

  @Prop()
  placeholder?: string;

  itemX = 0;
  itemWidth: number | null = null;
  instant = false;

  get displayValue() {
    if (this.placeholder !== undefined) {
      return this.placeholder;
    }

    return this.syncedValue;
  }

  get currentIndex() {
    return this.visibleItems?.findIndex(
      option => option.value === this.displayValue
    );
  }

  @Watch("syncedValue")
  onValueChange() {
    this.$nextTick(() => {
      this.recalculateIndicator();
    });
  }

  get items() {
    return this.control.items?.map(mapOptionToButtonBar) || [];
  }

  get visibleItems() {
    if (this.control.hideAfter) {
      const slicedItems = this.items?.slice(0, this.control.hideAfter);

      const isSelectedValueInVisibleItems = slicedItems?.some(
        item => item.value === this.displayValue
      );

      const selectedItem = this.items?.find(
        item => item.value === this.displayValue
      );

      if (selectedItem && !isSelectedValueInVisibleItems) {
        return slicedItems?.map((item, index) => {
          if (index === slicedItems.length - 1) {
            return { ...selectedItem };
          }

          return item;
        });
      }

      return slicedItems;
    } else {
      return this.items;
    }
  }

  get hiddenItems() {
    const items = this.items?.slice(this.control.hideAfter - 1) || [];
    if (items.length > 1) {
      items.push(items.shift()!);
    }
    return items;
  }

  get styles() {
    return {
      transition: this.instant ? "none" : "",
      transform: `translateX(${this.itemX}px)`,
      width: this.itemWidth ? `${this.itemWidth}px` : "0px"
    };
  }

  recalculateIndicator(instant = false) {
    this.instant = instant;

    this.$nextTick(() => {
      const items = (this.$refs.items || []) as HTMLElement[];

      if (this.currentIndex === -1 || this.currentIndex == undefined) {
        this.itemWidth = null;
        return;
      }

      const item = items[this.currentIndex];

      if (item) {
        this.itemX = item.offsetLeft;
        this.itemWidth = item.offsetWidth;
      }
    });
  }

  mounted() {
    this.recalculateIndicator(true);

    // Popouts take a few milliseconds to render, so we need to recalculate the indicator after a short delay
    setTimeout(() => this.recalculateIndicator(true), 100);
  }
}
